// LICENSE_CODE ZON
'use strict'; /*jslint ts:true*/
// @ts-ignore
import {get_user, perr} from './util.js';
import etask from 'zetask';
import experiment_init from './experiment_init';
// @ts-ignore
import cookie from 'cookie';
import {guess_browser} from 'zuser_agent';
// @ts-ignore
import {data as data_from_browser} from 'loadTimeData';
// @ts-ignore
import {qs_parse_url} from '/util/url.js';
import {guess_os_and_version} from './client_hints_global';
// @ts-ignore
import _ from 'zutil';
import _pick_by from 'lodash.pickby';

interface i_experiment_params {
    only_new?: boolean;
    user?: object_of<any>;
    email?: string;
    is_new_user?: boolean;
    unknown?: boolean; // unused
    need_check_user?: boolean;
    info?: object_of<any>;
    build?: object_of<any>;
    ignore_active?: boolean;
}

const find_if_in_has_event = (experiment_id:string, event:string)=>{
    const tests = Object.keys(experiment_init.ui_test_conf);
    tests.forEach(test=>{
        const conf = experiment_init.ui_test_conf[test];
        // @ts-ignore
        if (conf.is_active && conf.is_active.has_event)
        {
            // @ts-ignore
            const cfg_check = conf.is_active.has_event;
            if (cfg_check.test == experiment_id && cfg_check.event == event)
                experiment_init.redefine_test(test, true, location.host);
        }
    });
};

export const send = (experiment_id:string, event:string,
    p?:i_experiment_params)=>etask(function*(){
    const params = p || {unknown: true, need_check_user: false};
    const conf = experiment_init.ui_test_conf[experiment_id];
    const b = guess_browser();
    if (b.opera)
        b.browser = 'opera';
    if (b.edge)
        b.browser = 'edge';
    let ext_version = data_from_browser.ext_version;
    try {
        ext_version = window.document.documentElement
            .getAttribute('hola_ext_version');
    } catch(e){}
    const qs = qs_parse_url(window.location.href, {safe: true});
    let tests_from_browser_qs = {};
    try {
        tests_from_browser_qs =
            JSON.parse(decodeURIComponent(qs.browser_experiments));
    } catch(e){}
    let tests_from_browser_data = {};
    try {
        tests_from_browser_data =
        JSON.parse(decodeURIComponent(data_from_browser.browser_experiment));
    } catch(e){}
    const br_exp = tests_from_browser_qs[experiment_id]
        || tests_from_browser_data[experiment_id];
    const is_br_exp = br_exp=='ON' || br_exp=='OFF';
    const g_obj = guess_os_and_version();
    const checking_obj = Object.assign({
        pathname: window.location.pathname,
        os: g_obj.os,
        os_version: g_obj.version,
        os_and_version: `${g_obj.os}_${g_obj.version}`,
        browser: b.browser,
        search: window.location && window.location.search || '',
        ext_version: ext_version || qs.ext_version,
        tests: experiment_init.ui_test,
    // @ts-ignore
    }, window.init_prop);
    const is_test_enabled = typeof conf=='object' ? conf.on || 0 : conf;
    const need_to_check_active = params.ignore_active ? false :
        typeof conf=='object' ? !conf.ignore_active_for_send : true;
    if (!is_br_exp && !(is_test_enabled > 0 && is_test_enabled < 1))
        return;
    if (need_to_check_active && !is_br_exp
        && !experiment_init.check_is_active(checking_obj, conf))
    {
        return;
    }
    const {user} = !params.need_check_user ?
        {user: null} : yield get_user({cache: true});
    if (params.only_new && user)
        return;
    const user_to_send = user || params && (params.user
        || {emails: [{value: params.email}]});
    const pid = `www_exp_${experiment_id}.ev_${event}`;
    const data = {user: user_to_send} as object_of<any>;
    if (!user || params.is_new_user)
        data.is_new_user = true;
    if (!user && !params.need_check_user)
    {
        data.user = {
            emails: [{value: cookie.get('h_visitor_id')}],
        };
    }
    if (data.user && data.user.emails && data.user.emails[0]
        && data.user.emails[0].value)
    {
        find_if_in_has_event(experiment_id, event);
        try {
            yield perr({id: pid, info: {data, ...p?.info}, build: p?.build});
        } catch(e){ console.error(e); }
    }
});
// XXX dmitriiz: see if we'll use this idea different way
// move config to db and create mapping perr-event
export const get_action_experiments = (action: string)=>{
    return Object.keys(_pick_by(experiment_init.ui_test_conf, conf=>{
        const {log_actions} =
            typeof conf==='object' ? conf : {} as {log_actions?: any};
        return _.get(log_actions, action);
    }));
};
const experiment_util = {send, get_action_experiments};
export default experiment_util;
